import type { TableColumnSystemField } from '@tempo-io/roadmap-dto';
import {
  INTEGRATION_ITEM_EDITABLE_FIELDS,
  type IntegrationItemEditableField,
} from '@/lib/utils/loop-visualization/isItemEditable';
import { buildTableColumnField } from './tableColumnUtils';

const ITEM_PROP_TO_COLUMN_TYPE = {
  teamId: 'team',
  estimationId: 'estimation',
  plannedStartDateTime: 'plannedStartDate',
  plannedFinishDateTime: 'plannedFinishDate',
  itemStatusId: 'status',
} as const satisfies Record<IntegrationItemEditableField, TableColumnSystemField>;

const EXTERNALLY_WRITABLE = INTEGRATION_ITEM_EDITABLE_FIELDS.map((itemProp) => ({
  columnField: buildTableColumnField({
    type: ITEM_PROP_TO_COLUMN_TYPE[itemProp],
    customFieldId: null,
  }),
  itemProp,
}));

export const EXTERNALLY_WRITABLE_FIELDS: ReadonlySet<string> = new Set(
  EXTERNALLY_WRITABLE.map((f) => f.columnField),
);

export const EXTERNALLY_WRITABLE_BULK_EDIT_KEYS: ReadonlySet<string> = new Set(
  EXTERNALLY_WRITABLE.map((f) => f.itemProp),
);
